<template>
  <div class="payment-by-delivery-relation-settings">
    <div class="settings-scope-hint">
      <font-awesome-icon icon="info-circle" class="hint-icon" />
      <span>
        Настройте доступные методы оплаты для заказов оформленных клиентами на сайте, в мобильном приложении,
        а также сотрудниками на кассе филиала и в колл-центре.
      </span>
    </div>
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th>Тип / Оплата</th>
            <th class="text-center">
              Наличные
            </th>
            <th class="text-center">
              Терминал
            </th>
            <th class="text-center">
              Онлайн
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(label, deliveryType) in deliveryTypes" :key="deliveryType">
            <td>{{ label }}</td>
            <td v-for="(paymentLabel, paymentType) in paymentTypes" :key="paymentType" class="text-center">
              <div class="d-flex justify-center">
                <v-checkbox
                  v-model="localValue[deliveryType][paymentType]"
                  hide-details
                  class="ma-0 pa-0"
                  :disabled="disabled || (paymentType === 'online' && !onlinePaymentEnabled)"
                  @change="updateValue"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div v-if="errorMessage" class="error--text text-caption pa-2">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PaymentByDeliveryRelationSettings',
    props: {
      value: {
        type: [String, Object],
        default: () => ({}),
      },
      disabled: Boolean,
      onlinePaymentEnabled: {
        type: Boolean,
        default: true,
      },
    },
    data () {
      return {
        localValue: {
          delivery: { cash: false, terminal: false, online: false },
          self: { cash: false, terminal: false, online: false },
        },
        deliveryTypes: {
          delivery: 'Оплата при доставке курьером',
          self: 'Оплата на кассе / самовывоз',
        },
        paymentTypes: {
          cash: 'Наличные',
          terminal: 'Терминал',
          online: 'Онлайн',
        },
      }
    },
    computed: {
      errorMessage () {
        if (this.disabled) return null

        const errors = []
        for (const [type, label] of Object.entries(this.deliveryTypes)) {
          const methods = this.localValue[type]
          // Проверяем активные методы. Онлайн считается активным только если он включен глобально.
          const hasActiveMethod =
            methods.cash ||
            methods.terminal ||
            (methods.online && this.onlinePaymentEnabled)

          if (!hasActiveMethod) {
            errors.push(label)
          }
        }

        if (errors.length > 0) {
          return `Необходимо выбрать хотя бы один доступный способ оплаты для: ${errors.join(', ')}`
        }
        return null
      },
    },
    watch: {
      value: {
        handler (val) {
          this.parseValue(val)
        },
        deep: true,
        immediate: true,
      },
    },
    methods: {
      parseValue (val) {
        let parsed = val
        if (typeof val === 'string') {
          try {
            parsed = JSON.parse(val)
          } catch (e) {
            parsed = {}
          }
        }

        if (!parsed) parsed = {}

        const toBoolMap = (arr) => {
          const map = { cash: false, terminal: false, online: false }
          if (Array.isArray(arr)) {
            arr.forEach(type => {
              if (map[type] !== undefined) {
                map[type] = true
              }
            })
          }
          return map
        }

        this.localValue = {
          delivery: toBoolMap(parsed.delivery),
          self: toBoolMap(parsed.self),
        }
      },
      updateValue () {
        const fromBoolMap = (map) => {
          return Object.keys(map).filter(key => map[key])
        }

        const result = {
          delivery: fromBoolMap(this.localValue.delivery),
          self: fromBoolMap(this.localValue.self),
        }

        if (typeof this.value === 'string') {
          this.$emit('input', JSON.stringify(result))
        } else {
          this.$emit('input', result)
        }
      },
    },
  }
</script>

<style lang="less" scoped>
.payment-by-delivery-relation-settings {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  overflow: hidden;
}

// фирменная тёплая заметка CRM: мягкий градиент в тон бренда, без рамок
.settings-scope-hint {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 12px 12px 25px 12px ;
  padding: 12px 16px;
  background: linear-gradient(105deg, #fff9f0 0%, #ffefdb 100%);
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.5;
  color: #191919;

  .hint-icon {
    flex-shrink: 0;
    margin-top: 3px;
    font-size: 16px;
    .fill-svg(@color-primary);
  }
}
</style>
